export class LimePrescriptionStrategy {
  calculateLimePrescription() {
    throw new Error("Method 'calculateLimePrescription()' must be implemented.");
  }
}
